import { NavigationLink } from './navigation-link.type';

// TODO Add links properties for admin
export const adminNavigationLinks: NavigationLink[] = [];
